import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  Select,
  MenuItem,
  Box,
  Typography,
  ButtonBase
} from '@mui/material';

const LanguageSwitcher = ({ variant = 'select' }) => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es-MX', name: 'Español (México)', flag: '🇲🇽' }
  ];

  const isSpanish = (i18n.language || 'en').toLowerCase().startsWith('es');

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
  };

  // TKT-234 (Doug): the globe icon was not recognizable as a language
  // switcher. Replaced with an explicit "EN / SPN" text toggle — the
  // active language is emphasized, one tap switches to the other one.
  // Preference persists via the i18next localStorage cache. The legacy
  // app likewise used explicit text labels (ENGLISH / ESPAÑOL), not an
  // icon.
  if (variant === 'menu') {
    const segmentSx = (active) => ({
      fontWeight: active ? 700 : 400,
      opacity: active ? 1 : 0.6,
      textDecoration: active ? 'underline' : 'none',
      textUnderlineOffset: '3px',
      fontSize: '0.875rem',
      lineHeight: 1,
      letterSpacing: '0.03em'
    });

    return (
      <ButtonBase
        onClick={() => handleLanguageChange(isSpanish ? 'en' : 'es-MX')}
        aria-label={isSpanish ? t('common.switchToEnglish') : t('common.switchToSpanish')}
        sx={{
          color: 'inherit',
          px: 1,
          py: 0.75,
          borderRadius: 1,
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }
        }}
      >
        <Typography component="span" sx={segmentSx(!isSpanish)}>EN</Typography>
        <Typography component="span" sx={{ mx: 0.5, opacity: 0.6, fontSize: '0.875rem', lineHeight: 1 }}>/</Typography>
        <Typography component="span" sx={segmentSx(isSpanish)}>SPN</Typography>
      </ButtonBase>
    );
  }

  // Default select variant
  return (
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <Select
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        displayEmpty
        sx={{
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }
        }}
      >
        {languages.map((language) => (
          <MenuItem key={language.code} value={language.code}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span style={{ fontSize: '1.1em' }}>{language.flag}</span>
              <Typography variant="body2">{language.name}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSwitcher; 